module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/ER-5a5064aa48bb715346c975930ce0c9e7.png";